import actions from './actions';
import getters from './getters';
import mutations from './mutations';

import { LISTINGS } from '@/constants';

export const initState = () => ({
  error: null,
  isLoading: false,
  isAdding: false,
  isSending: false,
  paging: null,
  detail: null,
  sharedocs: [],
  latestRefresh: '',
  refreshStatus: LISTINGS.REFRESH_STATUS.UNKNOWN,
  refreshProgress: 0,
});

export default {
  namespaced: true,
  state: initState(),
  getters,
  mutations,
  actions,
};
